import React, { useEffect, useState } from 'react';

import { Alert, Box, Stack, TextField } from '@mui/material';

import { RuleCondition } from '~/consts/agentHub';

interface Props {
  setCreatedConditions: (condition: RuleCondition, replace?: boolean) => unknown;
  existingConditions: RuleCondition['value'];
}

function AgentHubCommissionsBundleTotalPriceInput({ setCreatedConditions, existingConditions }: Props) {
  const [minValue, setMinValue] = useState<number>((existingConditions?.[0]?.value as number) || 0);
  const [maxValue, setMaxValue] = useState<number | null>((existingConditions?.[1]?.value as number) ?? null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (maxValue && minValue >= maxValue) {
      setError('Min bundle total price must be less than the max bundle total price');
      return;
    }
    setError(null);

    setCreatedConditions(
      {
        type: 'bundleTotalPrice',
        value: [{ label: 'Min', value: minValue }, ...(maxValue ? [{ label: 'Max', value: maxValue }] : [])],
      },
      true,
    );
  }, [minValue, maxValue, setCreatedConditions]);

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ marginBottom: 2 }}>
          {error}
        </Alert>
      )}
      <Stack spacing={2} direction="row">
        <Box>
          <TextField
            required
            name="Min"
            value={minValue}
            onChange={(e) => {
              setMinValue(parseInt(e.target.value));
            }}
            InputProps={{ inputProps: { min: 0 }, sx: { borderRadius: 0.5 } }}
            label="Min"
            type="number"
            inputMode="decimal"
            fullWidth
          />
        </Box>
        <Box>
          <TextField
            name="Max"
            value={maxValue}
            onChange={(e) => {
              setMaxValue(parseInt(e.target.value));
            }}
            InputProps={{ inputProps: { min: 1 }, sx: { borderRadius: 0.5 } }}
            label="Max"
            type="number"
            fullWidth
          />
        </Box>
      </Stack>
    </Box>
  );
}

export default AgentHubCommissionsBundleTotalPriceInput;
